module.exports = __webpack_public_path__ + "static/media/01_andinvainthedreamer.94d51c50.jpg";